export const CUSTOM_FIELDS_ORDER = [
  "utilityProvider",
  "utilityTypeName",
  "country",
  "renewableEnergy",
  "startDate",
  "endDate",
];

export const SELECT_FIELDS = [
  "utilityProvider",
  "utilityTypeName",
  "country"
];

export const DATE_FIELDS = [
  "startDate",
  "endDate",
];
